import { PiGlobeSimpleFill, PiMoneyFill, PiGiftFill } from "react-icons/pi";
import ConsumerHero from "../../assets/images/consumer_engagement.png";
import RevenueHero from "../../assets/images/revenue.png";
import LoyaltyHero from "../../assets/images/loyalty_retention.png";

const Globe = PiGlobeSimpleFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Eth = PiMoneyFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;

const Gift = PiGiftFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;

export const solutionsData = [
  {
    sectionTitle: "Consumer Engagement & Activation",
    id: "consumer-engagement",
    sectionSubtitle:
      "Reach every customer instantly through direct mobile network integration that delivers personalized messages to any device in seconds. Our platform processes millions of customer actions in real-time, using predictive analytics to identify valuable customers and detect churn before it happens.",
    heroImage: ConsumerHero,
    icon: <Globe size={24} color="#2C73DB" />,
  },

  {
    sectionTitle: "Revenue Intelligence & Growth Optimization",
    id: "revenue-intelligence",
    sectionSubtitle:
      "Predict your highest-value customers before their next purchase with AI that analyzes hundreds of behavioral signals to forecast future spending patterns. Automated promotion testing identifies winning offers for each segment while balancing revenue growth with profit margins, giving you clear ROI tracking for every campaign.",
    heroImage: RevenueHero,
    icon: <Eth size={24} color="#2C73DB" />,
  },

  {
    sectionTitle: "Loyalty & Retention Automation",
    id: "loyalty-retention",
    sectionSubtitle:
      "Build flexible loyalty programs that automatically award and redeem points with every purchase, create VIP tiers with exclusive benefits, and integrate partner brands to expand your reward catalog. Turn satisfied customers into brand ambassadors with complete referral tracking across all touchpoints, flexible incentive structures that reward both parties",
    heroImage: LoyaltyHero,
    icon: <Gift size={24} color="#2C73DB" />,
  },
];
